/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'
import ReservationContext, { ReservationContextInterface } from './reservationContext'

export interface ReservationProps {
  reservation: ReservationContextInterface;
}

const withReservation = <P extends object>(Component: React.ComponentType<P & ReservationProps>) =>
  class WithLocale extends React.Component<P> {
    static contextType = ReservationContext

    render () {
      return (
        <Component
          {...this.props as P}
          reservation={this.context}
        />
      )
    }
  }

export default withReservation